module.exports = __webpack_public_path__ + "img/scene3_2.a2297595.svg";